import { Component, Input, OnInit } from '@angular/core';

import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { ButtonTypesEnum }  from '../../../../Common/Forms/enums/button-types.enum';
import { Digest } from '@Monitor/Briefings/models/digest.model';
import { DialogIoModel } from '@Core/Dialogs/models/dialog-io.model';
import { DigestShareDialogComponent } from '../DigestShareDialog/digest-share-dialog.component';
import { DigestService } from '@Monitor/Shared/services/digest.service';
import { DigestSubscriberApi } from '@api/briefings/model/digest-subscriber-api';
import { messageSeverityEnum } from '@Common/Misc/enums/message-severity.enum';

@Component({
    selector: 'agpr-digest-subscriber-dialog',
    templateUrl: './digest-subscriber-dialog.component.html',
    styleUrls: ['./digest-subscriber-dialog.component.scss'],
    standalone: false
})
export class DigestSubscriberDialogComponent extends AbstractDialogComponent implements OnInit {
    @Input() digest: Digest;

    readonly buttonType = ButtonTypesEnum;
    readonly messageSeverityEnum = messageSeverityEnum;

    filterQuery: string = '';
    subscribers: any[] = [];
    filteredSubscribers: any[] = [];

    constructor(
        public coreDialogService: CoreDialogService,
        private digestService: DigestService,
    ) {
        super(coreDialogService, 'DigestSubscriber');
    }

    ngOnInit(): void {
        this.digestService.getSubscribersByDigestId(this.digest.id).subscribe(subscribers => {
            this.subscribers = subscribers;

            this.filter();
        });
    }

    filter(): void {
        if (!this.filterQuery) {
            this.filteredSubscribers = this.subscribers;
        } else {
            this.filteredSubscribers = this.subscribers.filter(subscriber =>
                subscriber.email.toLowerCase().includes(this.filterQuery.toLowerCase())
            );
        }
    }

    share() {
        const io: DialogIoModel = {
            inputs: {
                digest: this.digest
            },
            outputs: {}
        };

        this.coreDialogService.open(DigestShareDialogComponent, io);
    }

    removeDigestSubscriber(subscriber: DigestSubscriberApi) {
        this.digestService.unsubscribe(this.digest.id, subscriber.id).subscribe();
    }
}
